export default __webpack_public_path__ + "static/media/areax_card.5c5cf907.png";